import gql from 'graphql-tag'

import { ITour, ITourQueryWhereUniqueInput } from './common';

export const TourPreviewFragment = gql`
	fragment TourPreviewFragment on Tour {
        id
        title
        image
	}
`

export const TourPreviewQuery = gql`
	query tourPreview($where: TourWhereUniqueInput!) {
		tour(where: $where) {
			...TourPreviewFragment
		}
	}
	${TourPreviewFragment}
`

export interface ITourPreviewQueryVariables {
    where: ITourQueryWhereUniqueInput
}

export interface ITourPreviewQueryData {
    tour: ITour
}